import { render, staticRenderFns } from "./ClaimsSettlement.vue?vue&type=template&id=5343cd32&scoped=true&"
import script from "./ClaimsSettlement.vue?vue&type=script&lang=js&"
export * from "./ClaimsSettlement.vue?vue&type=script&lang=js&"
import style0 from "./ClaimsSettlement.vue?vue&type=style&index=0&id=5343cd32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5343cd32",
  null
  
)

export default component.exports